import React from "react";
import Header from "./Header";
import Banner from "./Banner";
import Footer from "./Footer";
import TownHall from "./TownHall";
export default function Home() {
  return (
    <>
      <Header link={"home"} />
      <Banner />
      <TownHall />
      <Footer />
    </>
  );
}
